module.exports = __webpack_public_path__ + "static/media/m_hairstyle_buzz_front_vector.1b7c7ac3.svg";